import { APP_ROLE_ID } from '../../lib/constants';

export const defaultValues = {
  profiles: [
    { isActive: false, name: 'Dashboard', type: 'Dashboard' },
    { isActive: false, showAllLTOs: false, name: 'App', type: 'App', roleId: APP_ROLE_ID },
  ],
};
